import { Module } from 'vuex';
import { GlobalState } from '../types';
import { DestinationsState } from './types';

import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: DestinationsState = {
    destinations: [],
    selected: null
};

const namespaced: boolean = true;
export const destinations: Module<DestinationsState, GlobalState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
